import { Alert, AlertIcon,Container} from '@chakra-ui/react'
import React from 'react'

function ErrorCoins() {
  return (
    <Alert status='error' position={"fixed"} bottom={"4"} left={"50%"} transform={"translateX(-50%)"} w={'container.lg'}>
      <Container display={"flex"} justifyContent={"center"}>
      <AlertIcon/>
      Error While Fetching Icons
      </Container>
    </Alert>
  )
}

export default ErrorCoins
